<template>
    <a v-if="product" :href="product.url" tabindex="0" :aria-label="'Mit Enter zur Detailseite von ' + product.title + ' wechseln.'" class="products__item">
        <div class="products__dateicon">
            <svg width="33" height="33" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1" y="1" width="28.4642" height="29" rx="2" fill="white" />
                <rect x="0.66114" y="0.66114" width="29.1419" height="29.6777" rx="2.33886" stroke="#EB8909" stroke-opacity="0.3" stroke-width="0.677719" />
                <text class="products__dateicon--day" x="50%" y="50%" text-anchor="middle" fill="#EB8909" font-size="16" dy="2">{{ day }}</text>
                <text x="50%" y="85%" text-anchor="middle" fill="#EB8909" font-size="9">{{ month }}</text>
            </svg>
        </div>
        <div v-if="image" class="products__image products__iteminfo">
            <img :src="product.image" alt="">
        </div>
        <div class="products__title products__iteminfo">
            {{ product.title }}
        </div>
        <div class="products__category products__iteminfo">
            {{ Object.values(product.categories)[0] }}
        </div>
        <div v-if="product.startDate == product.endDate || !product.endDate" class="products__date products__iteminfo">
            {{ new Date(product.startDate).toLocaleDateString("de-DE", {day: "2-digit", month: "2-digit", year: "numeric"}) }}
        </div>
        <div v-else-if="product.startDate.split('-')[1] == product.endDate.split('-')[1]" class="products__date products__iteminfo">
            {{ product.startDate.split('-')[2] + ". - " + new Date(product.endDate).toLocaleDateString("de-DE", {day: "2-digit", month: "2-digit", year: "numeric"}) }}
        </div>
        <div v-else class="products__date products__iteminfo">
            {{ product.startDate.split('-')[2] + "." + product.startDate.split('-')[1] + ". - " + new Date(product.endDate).toLocaleDateString("de-DE", {day: "2-digit", month: "2-digit", year: "numeric"}) }}
        </div>
        <div class="products__place products__iteminfo">
            {{ product.place }}
        </div>
        <button @click.stop.prevent="toggleBookmark" @keyup.enter.stop :aria-label="isSaved ? 'Von Merkliste entfernen' : 'In Merkliste speichern'" :class="{'products__wishlist--saved': isSaved}" class="products__wishlist products__iteminfo">
            <svg class="products__bookmark" width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.25 14.75L6 11.75L0.75 14.75V2.75C0.75 2.35218 0.908035 1.97064 1.18934 1.68934C1.47064 1.40804 1.85218 1.25 2.25 1.25H9.75C10.1478 1.25 10.5294 1.40804 10.8107 1.68934C11.092 1.97064 11.25 2.35218 11.25 2.75V14.75Z" stroke="#5E5E5E" stroke-width="1.41667" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
    </a>
</template>

<script setup>
import { defineStore } from 'pinia';
import { computed } from 'vue';

const props = defineProps({
    product: Object,
    image: Boolean
})

const useBookmarkStore = defineStore('bookmark');

const bookmarkStore = useBookmarkStore();

const isSaved = computed(() => {
    let saved = false;
    bookmarkStore.bookmarks.forEach((bookmark) => {
        if(bookmark.id === props.product.id) {
            saved = true;
        }
    })
    return saved
})

function toggleBookmark(){
    let isBookmarked = false;
    bookmarkStore.bookmarks.forEach((bookmark) => {
        if(bookmark.id == props.product.id){
            isBookmarked = true;
        }
    })

    if(isBookmarked){
        bookmarkStore.removeBookmark(props.product.id);
    } else {
        bookmarkStore.addBookmark(props.product.id, props.product.startDate);
    }
}

// Tag und Monat extrahieren und umwandeln für SVG
const day = computed(() => props.product.startDate.split('-')[2]);
const month = computed(() => {
  const monthNumber = props.product.startDate.split('-')[1];
  const months = ['JAN', 'FEB', 'MÄR', 'APR', 'MAI', 'JUN', 'JUL', 'AUG', 'SEP', 'OKT', 'NOV', 'DEZ'];
  return months[parseInt(monthNumber) - 1];
});
</script>
